<header
  class="dashboard-header d-flex align-items-center justify-content-between position-sticky top-0 m-0 rounded-0 py-2 px-3 px-md-4 z-3"
>

  <!-- LEFT: Hamburger (mobile) + Breadcrumb -->
  <div class="d-flex align-items-center gap-3">

    <!-- 🍔 MOBILE SIDEBAR TOGGLE -->
    <button
      v-if="is_mobile"
      class="btn dashboard-mobile-toggle btn-sm rounded-circle d-flex align-items-center justify-content-center"
      @click="$emit('toggle-mobile-sidebar')"
    >
      <i class="bi bi-list"></i>
    </button>

    <!-- Breadcrumb -->
    <div class="breadcrumb d-flex align-items-center flex-wrap gap-0 mb-0">

      <template v-if="breadcrumb && breadcrumb.length">
        <span
          v-for="(crumb, i) in breadcrumb"
          :key="crumb.id + '-' + i"
          class="d-flex align-items-center "
        >
          <a
            v-if="i < breadcrumb.length - 1"
            href="#"
            @click.prevent="$emit('breadcrumb-click', crumb.id)"
            class="text-header-dark text-decoration-none dashboard-breadcrumb-link"
          >
            {{ crumb.title }}
          </a>

          <span
            v-else
            class="text-header-dark fw-semibold dashboard-breadcrumb-current"
          >
            {{ crumb.title }}
          </span>

          <span v-if="i < breadcrumb.length - 1" class="text-header-dark mx-2 dashboard-breadcrumb-separator">/</span>
        </span>
      </template>

      <span v-else class="text-header-dark fw-semibold dashboard-breadcrumb-current">
        Dashboard
      </span>

    </div>
  </div>

  <!-- RIGHT: Actions -->
  <ul class="navbar-nav dashboard-header-actions flex-row align-items-center gap-2 gap-md-3 pe-2">

    <!-- 🤖 AI Campus VSI assistant (icon only on phones) -->
    <li class="nav-item">
      <BolideAssistantButton @open-assistant="openAssistant" />
    </li>

    <!-- User Management -->
    <li class="nav-item">
      <router-link to="/user-management" class="nav-link dashboard-header-icon d-inline-flex align-items-center justify-content-center rounded-circle text-header-dark p-0" aria-label="User Management">
        <i class="bi bi-people-fill fs-6"></i>
      </router-link>
    </li>

    <!-- Logout -->
    <li class="nav-item">
      <a
        href="#"
        class="nav-link dashboard-header-icon d-inline-flex align-items-center justify-content-center rounded-circle text-header-dark p-0"
        @click.prevent="logoutUser"
      >
        <i class="bi bi-box-arrow-right fs-6"></i>
      </a>
    </li>

  </ul>

</header>
